import { FilterDto } from '@act/shared/data-transfer-objects';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import { Control, FieldValues } from 'react-hook-form';
import { DialogFooter } from '../dialog/dialog-footer';
import { DialogHeader } from '../dialog/dialog-header';
import {
  DialogContentContainer,
  DialogMainContent,
} from '../dialog/dialogStyledComponents';
import FilterSelect from './filter-select';

interface FilterDialogProps<TFieldValues extends FieldValues = FieldValues> {
  open: boolean;
  control: Control<TFieldValues>;
  filters: FilterDto[];
  handleClose: () => void;
  handleReset: () => void;
  handleFiltering: () => void;
}

const FilterDialog = function <T>({
  open,
  control,
  filters,
  handleClose,
  handleReset,
  handleFiltering,
}: FilterDialogProps<T>) {
  return (
    <Dialog
      maxWidth="md"
      open={open}
      onClose={handleClose}
      role="dialog"
      aria-label="Call filter dialog"
      PaperProps={{
        sx: {
          '@media screen and (max-width: 425px)': {
            width: '100vw',
          },
        },
      }}
    >
      <DialogContentContainer>
        <DialogHeader
          postfixAction={{
            title: 'close',
            callback: handleClose,
            icon: <CloseIcon />,
          }}
        >
          Filters
        </DialogHeader>
        <DialogMainContent>
          {filters?.map(f => {
            return <FilterSelect key={f.name} filter={f} control={control} />;
          })}
        </DialogMainContent>
        <DialogFooter
          actions={[
            { text: 'Reset', callback: handleReset },
            {
              text: 'Apply',
              callback: handleFiltering,
              isPrimary: true,
            },
          ]}
        />
      </DialogContentContainer>
    </Dialog>
  );
};

export default FilterDialog;
